import { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';
import LoadingButton from 'components/loading_button';

export default function ResetPassword() {
  const [submissionMessage, setSubmissionMessage] = useState('');
  const [submissionClass, setSubmissionClass] = useState('alert-info');

  const onSubmit = (params, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setSubmitting(true);
    setSubmissionMessage(null);
    setSubmissionClass('alert-info');

    EcomEngineAPI.account.resetPassword(params).then((result) => {
      setSubmitting(false);

      if (result.success) {
        const message = `If an account exists for ${params.username}, you will get an email with instructions on resetting your password. If it doesn't arrive, be sure to check your spam folder.`;
        setSubmissionMessage(message);
      }
    });
  };

  const formSchema = Yup.object().shape({
    username: Yup.string().required('Username or Email is required'),
  });

  return (
    <Formik
      initialValues={{
        username: '',
      }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <div className="row">
          <div className="col-12 col-lg-7 mx-auto">
            <div className="p-5 my-md-5 bg-white border space-y-4">
              <h2>Reset your password</h2>
              <div className="content text-small">
                <p>
                  If you are already registered but have forgotten your
                  password:
                </p>
                <ol>
                  <li>Enter your registered username or email.</li>
                  <li>
                    An email will be sent to your email address which contains
                    information about password recovery.
                  </li>
                  <li>
                    Please click the link in the email to reset your password.
                  </li>
                </ol>
              </div>

              {submissionMessage && (
                <div
                  className={`alert ${submissionClass} alert-dismissible fade show text-small`}
                >
                  {submissionMessage}
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setSubmissionMessage(null)}
                  />
                </div>
              )}

              <Form className="needs-validation reset-password__form">
                <div className="form-group">
                  <label htmlFor="username">Username or Email</label>
                  <div>
                    <Field
                      name="username"
                      className="form-control"
                      id="username"
                      placeholder="Username or Email"
                    />
                  </div>
                  <ErrorMessage
                    className="text-danger text-small mt-1"
                    name="username"
                    component="div"
                    id="username_error"
                  />
                </div>

                <div className="mt-4">
                  <LoadingButton
                    type="submit"
                    disabled={isSubmitting}
                    className="btn btn-primary"
                    loading={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Reset password'}
                  </LoadingButton>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
}
